import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const autocompleteWrapper: ThemedFunctor = ({
  theme,
}) => css`
  background: ${theme.color.background.neutral.default.low};
  padding: ${theme.remSize[150]};
  border: 1px solid ${theme.color.border.neutral.default.high};
  border-radius: ${theme.remRounding['2XS']};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding: ${theme.remSize[200]};
  }
`;

export const previewWrapper: ThemedFunctor = () => css`
  position: relative;
  z-index: 3;
`;

export const dataWrapper: ThemedFunctor = ({
  theme,
}) => css`
  padding: ${theme.remSize[150]};
  border: 1px solid ${theme.color.border.neutral.default.high};
  border-top: 0;
  border-radius: 0 0 ${theme.remRounding['2XS']} ${theme.remRounding['2XS']};
  margin-top: -${theme.remSize[100]};
  position: relative;
  background: ${theme.color.background.neutral.default.lowest};

  &::before {
    content: '';
    height: ${theme.remSize[100]};
    width: 100%;
    display: block;
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    padding: ${theme.remSize[200]};
  }
`;

export const formWrapper: ThemedFunctor = ({
  theme,
}) => css`
  ${dataWrapper({ theme })}
  background: ${theme.color.background.neutral.default.low};
  z-index: 2;
`;

export const extraDataWrapper: ThemedFunctor = ({
  theme,
}) => css`
  ${dataWrapper({ theme })}
  padding: 0 !important;
  overflow:hidden;
  z-index: 1;
`;

export const divider: ThemedFunctor = ({ theme }) => css`
  height: 0;
  border-top: 1px solid ${theme.color.border.neutral.default.high};
`;
